import { IconNames } from '@blueprintjs/icons';
import { Icon } from '@strata/react-status-icons';
import * as PropTypes from 'prop-types';

const TreatmentIssues = {
    NO_RECENT_EVIDENCE: 'NO_RECENT_EVIDENCE',
    NO_PA: 'NO_PA',
    UNMANAGED_MISSING_PAYER_PRODUCT_CONFIG: 'UNMANAGED_MISSING_PAYER_PRODUCT_CONFIG',
    UNMANAGED_MISSING_ELIGIBILITY_RECORD: 'UNMANAGED_MISSING_ELIGIBILITY_RECORD',
};

const TreatmentIssuesDisplayTextMap = {
    [TreatmentIssues.NO_RECENT_EVIDENCE]: 'No recent evidence',
    [TreatmentIssues.NO_PA]: 'Missing PA',
    [TreatmentIssues.UNMANAGED_MISSING_PAYER_PRODUCT_CONFIG]:
        'Unmanaged: Missing payer product config',
    [TreatmentIssues.UNMANAGED_MISSING_ELIGIBILITY_RECORD]: 'Unmanaged: Missing eligibility record',
};

export const TreatmentIssuesIcon = ({ issues }) =>
    issues.length > 0 ? (
        <Icon
            title="Issues"
            icon={IconNames.ISSUE}
            intent={
                issues.includes(TreatmentIssues.NO_RECENT_EVIDENCE)
                    ? Icon.Intent.WARNING
                    : Icon.Intent.DEFAULT
            }
            tooltipContent={issues.map((issue) => (
                <div key={issue}>{TreatmentIssuesDisplayTextMap[issue]}</div>
            ))}
        />
    ) : null;

TreatmentIssuesIcon.TreatmentIssues = TreatmentIssues;
TreatmentIssuesIcon.TreatmentIssuesDisplayTextMap = TreatmentIssuesDisplayTextMap;

TreatmentIssuesIcon.propTypes = {
    issues: PropTypes.arrayOf(PropTypes.oneOf(Object.values(TreatmentIssues))).isRequired,
};
